import React, { useLayoutEffect, useState } from 'react';
import ddt from '@wix/da-ddt';
import { useViewBlockChecks } from '../../DeviationViews/Full/hooks/useViewBlockChecks';
import { DEFAULT_MULTI_IMAGE_STAGE } from '../constants';
import { MultiArtDisplayMode, DefaultArtStageProps as Props } from '../types';
import { useAdditionalMedia } from '../hooks/useAdditionalMedia';
import { useMultiArtCurrentImageTracking } from '../hooks/useMultiArtCurrentImageTracking';
import { useMultiArtDeepLinking } from '../hooks/useMultiArtDeepLinking';
import DesktopMultiArtScrollStage from './DesktopMultiArtScrollStage';
import DesktopMultiArtCarouselStage from './DesktopMultiArtCarouselStage';

const logger = ddt.createLogger('multifile');

export const DesktopMultiArtStage: React.FC<Props> = props => {
  const { deviation } = props;

  const [displayMode, setDisplayMode] = useState<MultiArtDisplayMode>(
    DEFAULT_MULTI_IMAGE_STAGE
  );
  // if disabled, only show carousel
  const { hasBlock, isBlockedByMature } = useViewBlockChecks(deviation);
  const StageComponent =
    displayMode === 'scroll' && !hasBlock
      ? DesktopMultiArtScrollStage
      : DesktopMultiArtCarouselStage;

  const additionalMedia = useAdditionalMedia(deviation);
  const [currentlyViewedImageSource, setCurrentlyViewedImageSource] =
    useMultiArtCurrentImageTracking(deviation, additionalMedia);
  useMultiArtDeepLinking(additionalMedia, setCurrentlyViewedImageSource);

  // when duperbrowse switches between deviations, reset to show main image
  useLayoutEffect(() => {
    setCurrentlyViewedImageSource(deviation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviation.deviationId]);

  logger.log('DesktopMultiArtStage', {
    deviation: deviation.deviationId,
    displayMode,
    hasBlock,
    currentlyViewedImageSource:
      currentlyViewedImageSource?.['title'] ??
      currentlyViewedImageSource?.['filename'],
  });

  return (
    <StageComponent
      {...props}
      disabled={hasBlock}
      additionalMedia={additionalMedia}
      // blurring for mature is clientside
      shouldBlur={isBlockedByMature}
      setDisplayMode={setDisplayMode}
      currentlyViewedImageSource={currentlyViewedImageSource}
      setCurrentlyViewedImageSource={setCurrentlyViewedImageSource}
    />
  );
};
DesktopMultiArtStage.displayName = 'DesktopMultiArtStage';
export default DesktopMultiArtStage;
